<div class="card-apply-coupon" [ngClass]="{ 'is-desktop': isDesktop, 'form-row': isDesktop }" *ngIf="isCouponAvailable$ | async">
  <div class="col-8">
    <app-control-wrapper
      [control]="couponControl"
      [errors]="errors"
      [errorsOverrideParams]="{ DISCOUNT_IS_NOT_FOUND: { couponName: couponControl.value } }"
      [isShowHelper]="false"
    >
      <label for="coupon" control-label *ngIf="!isDesktop">{{ "LABELS.COUPON" | translate }}</label>
      <input
        type="text"
        class="form-control"
        id="coupon"
        name="coupon"
        [formControl]="couponControl"
        mask="F{1000}"
        appMaskErrorTooltip="MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL"
        control-wrapper
        [dropSpecialCharacters]="false"
        [patterns]="CUSTOM_MASK"
      />
    </app-control-wrapper>
  </div>

  <div class="col-4" [fxFlexAlign]="isDesktop ? 'flex-start' : 'center'">
    <button class="btn btn-primary card-apply-coupon-btn" (click)="apply.emit(couponControl.value)">
      {{ "BUTTON.APPLY" | translate }}
    </button>
  </div>
</div>
